import { z } from 'zod';

/**
 * KAMPANYA DİREKTÖRÜ — sihirbazın yanındaki sohbet (22 Ağu 2026).
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * Ne yapıyor: SİHİRBAZI DOLDURUYOR. Ne yapmıyor: KAMPANYA AÇMIYOR.
 * ═══════════════════════════════════════════════════════════════════════════
 * `creative-director.ts` ile AYNI karar ve aynı gerekçe zinciri — ama burada
 * bahis daha yüksek, çünkü kreatif üretimi KREDİ yakıyor, kampanya YAYINA
 * ALINDIĞINDA GERÇEK PARA harcıyor.
 *
 * Model bir tur sonunda üç şey döndürüyor: söyleyeceği cümle, formun
 * yamalanmış hâli ve (gerekiyorsa) tek bir soru. Yamayı ARAYÜZ uyguluyor,
 * alanlar kullanıcının GÖZÜ ÖNÜNDE doluyor, `POST /rmf/*` çağrılarına yine
 * kullanıcı basıyor.
 *
 * Doğrudan `/rmf/campaigns` çağıran bir araç yazılabilirdi ve bilerek
 * yazılmadı:
 *
 *   · Yanlış anlaşılmış bir cümle, platformda kullanıcının elle silmesi
 *     gereken bir nesne bırakır. Duraklatılmış doğduğu için para harcamaz
 *     ama "neden iki kampanya var" sorusunun cevabı hiçbir ekranda yazmaz.
 *   · Yamayı görmek bir DENETİM. Model yanlış ülkeyi ya da on katı bir bütçe
 *     seçtiyse kullanıcı bunu formda görür; gizli bir araç çağrısında ancak
 *     faturada görürdü.
 *   · Elle sihirbaz YEDEK olarak kalıyor (ürün kararı, 22 Ağu 2026). Ajanın
 *     günlük sayacı dolduğunda ya da sağlayıcı ucu düştüğünde kullanıcı
 *     kampanya açamaz duruma DÜŞMEMELİ.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * 🔴 KONUŞMA SAKLANIYOR — kreatif direktöründen AYRILDIĞI yer
 * ═══════════════════════════════════════════════════════════════════════════
 * Kreatif direktörü konuşmayı saklamıyor: sekme kapanınca gidiyor ve bu kabul
 * edilmiş bir bedeldi, çünkü o sohbet KENDİ EKRANINDA yaşıyor ve çıktısı
 * formda duruyor.
 *
 * Bu direktör ajan sayfasının İÇİNDE yaşıyor (ürün kararı, 22 Ağu 2026) ve
 * orada her sohbet sol listede duruyor. Kaydedilmeyen bir kampanya oturumu, o
 * listede aranıp bulunamayan bir sohbet olurdu — aynı sayfada bazı sohbetlerin
 * kaydedilip bazılarının kaydedilmemesi, kullanıcıya açıklanamaz.
 *
 * Bu yüzden `AgentConversation` şemaya iki alan aldı: `kind` (GENERAL /
 * CAMPAIGN) ve `draft` (yarım kalan form). Yarım bırakılan bir kampanya
 * oturumu, kaldığı yerden devam ediyor.
 */

/// Bir istekte taşınabilecek en fazla mesaj (kullanıcı + asistan toplamı).
/// Aşan kısmı arayüz BAŞTAN kırpıyor: en yeni tur her zaman içeride kalmalı.
export const CAMPAIGN_DIRECTOR_TURN_MAX = 24;

/// Tek bir mesajın uzunluk tavanı.
export const CAMPAIGN_DIRECTOR_MESSAGE_MAX = 2000;

/**
 * 🔴 TUR BAŞINA 0 KREDİ — kreatif direktörüyle aynı karar.
 *
 * Adil kullanım GÜNLÜK MESAJ SAYACIYLA korunuyor ve sayaç ajanınkiyle ORTAK
 * (`AgentLimitService`): üçü de aynı kaynağı (LLM turu) tüketiyor ve
 * kullanıcıya üç ayrı kotayı anlatmanın hiçbir karşılığı yok.
 */
export const CAMPAIGN_DIRECTOR_CREDITS = 0;

/// Modele gösterilen ürün sayısının tavanı. Katalog sistem prompt'una
/// gömülüyor (araçla sorulmuyor) ve her ürün satırı jeton yakıyor.
export const CAMPAIGN_DIRECTOR_PRODUCT_LIMIT = 40;

/// Bir sorunun taşıyabileceği en fazla şık.
export const CAMPAIGN_DIRECTOR_OPTION_MAX = 4;

/* -------------------------------------------------------------------------- */
/* Hedef — normalize edilmiş, dar küme                                         */
/* -------------------------------------------------------------------------- */

/**
 * 🔴 BURADA NORMALİZE EDİLDİ, `CreateCampaignInput.objective`TE EDİLMEDİ.
 *
 * Adapter sözleşmesi hedefi bilerek normalize etmiyor: hedef kümesi platform
 * başına farklı ve eşleme kaybettiriyor (`connector.types.ts`). O karar
 * ADAPTER için doğru — ama MODEL için değil. Serbest metin bir `objective`
 * alanı, modelin `OUTCOME_PURCHASE` gibi var olmayan bir sözcük uydurmasına
 * açık kapı bırakır ve hata ancak platform çağrısında, kullanıcı "Oluştur"a
 * bastıktan sonra görünür.
 *
 * Bu yüzden model DAR bir kümeden seçiyor; platform sözcüğüne çeviren tablo
 * `campaign-director-brief.ts` içinde ve tek yönlü.
 *
 * ⚠️ `sales` KASITLI OLARAK YOK. Dönüşüm optimizasyonu piksel istiyor
 * (`promoted_object.pixel_id`) ve bu akışın ürünleri PAZARYERİ sayfalarında
 * yaşıyor — Trendyol'un ürün sayfasına piksel kurulamıyor. Listeye
 * konsaydı model onu seçerdi (en "doğru" hedef gibi görünür), Meta ad set
 * adımında reddederdi ve kullanıcı sebebini anlamazdı. Kendi alan adına
 * (Shopify) reklam veren bir akış eklendiğinde buraya girer.
 */
export const CAMPAIGN_DIRECTOR_OBJECTIVES = ['traffic', 'awareness', 'engagement'] as const;
export const campaignDirectorObjectiveSchema = z.enum(CAMPAIGN_DIRECTOR_OBJECTIVES);
export type CampaignDirectorObjective = z.infer<typeof campaignDirectorObjectiveSchema>;

/* -------------------------------------------------------------------------- */
/* Formun modele gösterilen hâli                                               */
/* -------------------------------------------------------------------------- */

/**
 * Modelin GÖRDÜĞÜ ve YAZABİLDİĞİ alanlar — tam liste.
 *
 * ⚠️ Sihirbazın durumunun TAMAMI DEĞİL. Dışarıda bırakılanlar ve nedenleri:
 *
 *   · `productId` → kullanıcı pazaryerinden AÇIKÇA seçti. Modelin onu
 *     değiştirmesi, kullanıcının yaptığı tek net seçimi geri almak olurdu.
 *   · `adAccountId` → aynı gerekçe; ayrıca yanlış hesap yanlış para birimi
 *     ve yanlış fatura demek.
 *   · `identityRef` (Meta Sayfa kimliği) → kullanıcının bildiği bir numara,
 *     modelin tahmin edebileceği bir şey değil. Uydurursa reklam adımı
 *     "sayfa belirlenemedi" ile ölür ve model neden olduğunu bilemez.
 *   · `linkUrl` → ürünün KENDİ adresinden geliyor, sunucu dolduruyor. Model
 *     yazabilseydi ürünün adresi yerine markanın ana sayfasını önerebilirdi
 *     ve tıklama başına ödenen para yanlış yere giderdi.
 *   · yayına alma → hiçbir koşulda. Para harcatan tek çağrı ayrı kalıyor.
 */
export const campaignDirectorFormSchema = z.object({
  /* ── Kampanya ─────────────────────────────────────────────────────────── */
  campaignName: z.string().trim().min(1).max(200).optional(),
  objective: campaignDirectorObjectiveSchema.optional(),
  /**
   * Hesabın para biriminde ANA birim (kuruş değil).
   *
   * Alt sınır BURADA yok ve bu bilinçli: minimum günlük bütçe HESABA göre
   * değişiyor (Meta `min_daily_budget` döndürüyor, By Nini hesabında
   * 47,88 TRY). Şemaya sabit bir sayı yazmak, başka para biriminde açılmış
   * bir hesapta yalan söylerdi. Gerçek sınır brief'e hesaptan okunarak
   * yazılıyor ve arayüz de aynı sayıyla doğruluyor.
   */
  dailyBudget: z.number().positive().max(1_000_000).optional(),
  /// Kaç gün yayında kalacağı. Ad set'in `endTime`ını üretiyor.
  durationDays: z.number().int().min(1).max(90).optional(),

  /* ── Ad set ───────────────────────────────────────────────────────────── */
  adSetName: z.string().trim().min(1).max(200).optional(),
  /// ISO 3166-1 alfa-2, büyük harf. Meta hedeflemesiz ad set kabul etmiyor.
  countries: z.array(z.string().trim().length(2).toUpperCase()).min(1).max(20).optional(),
  ageMin: z.number().int().min(13).max(65).optional(),
  ageMax: z.number().int().min(13).max(65).optional(),
  /// Boş dizi "hepsi" DEĞİL, "seçim yok" demek — arayüz alanı hiç göndermiyor.
  genders: z
    .array(z.enum(['male', 'female']))
    .min(1)
    .max(2)
    .optional(),

  /* ── Reklam ───────────────────────────────────────────────────────────── */
  /**
   * SEÇİLEN KREATİFLER — her biri BİR REKLAM olacak.
   *
   * ═════════════════════════════════════════════════════════════════════════
   * 🔴 MODEL BUNU YAZMIYOR — arayüz yazıyor (22 Ağu 2026)
   * ═════════════════════════════════════════════════════════════════════════
   * İlk sürümde tekil `creativeId` vardı ve modelin yazdığı bir alandı. İki
   * ayrı arıza üretti:
   *
   *   · Model kendi listesinden seçiyordu ve o liste KIRPILMIŞTI (12 satır).
   *     Arayüz 48 gösterince kullanıcı modelin göremediği bir kreatifi seçti;
   *     model "listemde yok" dedi ve haklıydı. İki farklı liste, tek bir
   *     alanın iki farklı doğrusu demekti.
   *   · Tekil alan, "üç reklam açalım" planını taşıyamıyordu.
   *
   * Alan artık `productId` ve `adAccountId` ile AYNI sınıfta: kullanıcının
   * ekranda açıkça yaptığı bir seçim, modelin tahmin edeceği bir şey değil.
   * Araç şemasında YOK, yani model onu değiştiremiyor — ama formda GÖRÜYOR
   * ve kaç reklam açılacağını biliyor.
   *
   * Sıra ANLAMLI DEĞİL: her kimlik bir reklam, aralarında öncelik yok.
   */
  creativeIds: z.array(z.uuid()).min(1).max(10).optional(),
  /// Meta feed'de ~40 karakterden sonra kırpıyor; tavan yine de cömert.
  headline: z.string().trim().min(1).max(200).optional(),
  /// ~125 karakterden sonra "devamı" ile katlanıyor; ilk cümle taşımalı.
  bodyText: z.string().trim().min(1).max(1000).optional(),
  ctaType: z.string().trim().min(1).max(64).optional(),
});
export type CampaignDirectorForm = z.infer<typeof campaignDirectorFormSchema>;

/* -------------------------------------------------------------------------- */
/* Soru                                                                        */
/* -------------------------------------------------------------------------- */

/**
 * DİREKTÖRÜN SORDUĞU SORU — tur başına EN FAZLA BİR TANE.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * 🔴 NEDEN TEK SORU
 * ═══════════════════════════════════════════════════════════════════════════
 * Kullanıcının isteği "adım adım, fikrimin gerekli olduğu yerde sor" idi.
 * Bir turda üç soru sormak o isteğin tersi: kullanıcı formu doldurmuş gibi
 * hisseder, sohbet hissi kaybolur ve cevaplardan hangisinin neye ait olduğu
 * karışır.
 *
 * Şıklar kreatif direktöründeki gerekçeyle aynı şekilde disiplin de kuruyor:
 * cevabı üç-dört seçeneğe sığmayan bir soru, muhtemelen sorulmaması gereken
 * bir sorudur. `options` boş gelirse arayüz soruyu düz mesaj gibi basıyor ve
 * kullanıcı yazarak cevaplıyor — bütçe gibi gerçekten açık uçlu bir alan
 * için bu doğru davranış.
 */
export interface CampaignDirectorQuestion {
  text: string;
  /// Şıkkın METNİ cevabın kendisi — tıklama o metni kullanıcı mesajı olarak
  /// gönderiyor. Ayrı bir `value` alanı yok: değer taşıyan bir şık, konuşma
  /// geçmişinde koduyla görünür ve model bir sonraki turda okuyamaz.
  options: string[];
}

export const campaignDirectorMessageSchema = z.object({
  role: z.enum(['user', 'assistant']),
  text: z.string().trim().min(1).max(CAMPAIGN_DIRECTOR_MESSAGE_MAX),
});
export type CampaignDirectorMessage = z.infer<typeof campaignDirectorMessageSchema>;

/* -------------------------------------------------------------------------- */
/* Tur                                                                         */
/* -------------------------------------------------------------------------- */

export const campaignDirectorTurnSchema = z.object({
  /**
   * Sohbetin kimliği. İLK TURDA YOK — sunucu oluşturup geri döndürüyor.
   *
   * ⚠️ Konuşma İKİ YERDE birden duruyor ve bu bilinçli bir gerginlik:
   * istemci `messages` dizisini her turda taşıyor (model bağlamı oradan
   * okuyor), sunucu da aynı mesajları `agent_messages`a yazıyor (sekme
   * kapanınca geri gelebilsin diye).
   *
   * Tek kaynağa indirilebilirdi ve indirilmedi: sunucuyu tek kaynak yapmak
   * her turda konuşmanın tamamını OKUMAK demekti (fazladan bir sorgu, ve
   * kırpma mantığının sunucuya taşınması); istemciyi tek kaynak yapmak ise
   * kalıcılığı tümden kaldırırdı. Yazma tek yönlü olduğu için ayrışma riski
   * dar: sunucu yalnızca EKLİYOR, istemcinin gönderdiğini düzeltmiyor.
   */
  conversationId: z.uuid().optional(),
  /// BİZİM `AdAccount.id`imiz — platform kimliği değil. Kiracı doğrulaması
  /// bunun üzerinden yapılıyor ve hesabın para birimi/min bütçesi buradan
  /// okunup brief'e yazılıyor.
  adAccountId: z.uuid(),
  /**
   * BİZİM `Product.id`imiz. ZORUNLU — bu akışın giriş kapısı pazaryeri ve
   * ürün seçimi (ürün kararı, 22 Ağu 2026).
   *
   * Ürünsüz bir tur da düşünülebilirdi ("bana bir kampanya kur") ve
   * REDDEDİLDİ: kampanyanın hedef adresi, metni ve kitlesi ürüne dayanıyor.
   * Ürün olmadan model üçünü de uydurur.
   */
  productId: z.uuid(),
  /// Konuşma. Arayüz baştan kırpıyor; sunucu yalnız tavanı doğruluyor.
  messages: z.array(campaignDirectorMessageSchema).min(1).max(CAMPAIGN_DIRECTOR_TURN_MAX),
  /// Formun ŞU ANKİ hâli. Model bunun üstüne yama yazıyor; sıfırdan
  /// doldurmuyor, yoksa kullanıcının elle düzelttiği alanı geri alırdı.
  form: campaignDirectorFormSchema,
});
export type CampaignDirectorTurnInput = z.infer<typeof campaignDirectorTurnSchema>;

export interface CampaignDirectorTurnResponse {
  /// Sohbetin kimliği — ilk turda YENİ üretilmiş olanı taşıyor. İstemci bunu
  /// saklayıp sonraki turlarda geri gönderiyor ve adres çubuğuna yazıyor.
  conversationId: string;
  /// Kullanıcıya gösterilecek cümle. İki-dört cümle; brief bunu zorluyor.
  reply: string;
  /// Formun YAMALANMIŞ hâli — arayüz bunu mevcut formun üstüne uyguluyor.
  form: CampaignDirectorForm;
  /// Sorulacaksa tek soru; sorulmayacaksa null.
  question: CampaignDirectorQuestion | null;
  /**
   * Model formu TAMAMLANMIŞ sayıyor mu.
   *
   * Arayüzün "Kampanyayı oluştur" düğmesini AÇMASI için yeterli DEĞİL —
   * zorunlu alanların gerçekten dolu olduğunu arayüz kendi doğruluyor.
   * Bu bayrak yalnız modelin niyetini taşıyor: "benden istediğin bilgi
   * bitti" demek. İkisini ayırmak zorunlu, çünkü model `true` derken bir
   * alanı unutmuş olabilir ve düğmenin açılması onun kararına bırakılamaz.
   */
  ready: boolean;
}

/**
 * KAYDEDİLMİŞ OTURUMUN TAMAMI — sekme kapanıp açıldığında geri yüklenen şey.
 *
 * 🔴 `productId` ve `adAccountId` TASLAĞIN İÇİNDE saklanıyor, formun değil.
 * Sebep `campaignDirectorFormSchema` başlığında yazılı: ikisi de MODELİN
 * yazamayacağı alanlar ve forma konsaydı model onları değiştirmeye
 * çalışabilirdi. Ama oturumu sürdürmek için ikisi de ZORUNLU — ürünsüz bir
 * turun brief'i kurulamıyor.
 */
export interface CampaignDirectorSession {
  conversationId: string;
  productId: string;
  adAccountId: string;
  form: CampaignDirectorForm;
  messages: CampaignDirectorMessage[];
}

export const CampaignDirectorErrorCode = {
  /// Sağlayıcı yapılandırılmamış (ANTHROPIC_API_KEY yok) ya da ucu düştü.
  DIRECTOR_UNAVAILABLE: 'DIRECTOR_UNAVAILABLE',
  /// Günlük mesaj sayacı doldu — ajanla ORTAK sayaç.
  DIRECTOR_LIMIT_REACHED: 'DIRECTOR_LIMIT_REACHED',
  /// Ürün bu çalışma alanında yok ya da reklama uygun değil.
  DIRECTOR_PRODUCT_NOT_USABLE: 'DIRECTOR_PRODUCT_NOT_USABLE',
} as const;
export type CampaignDirectorErrorCode =
  (typeof CampaignDirectorErrorCode)[keyof typeof CampaignDirectorErrorCode];
